export default {
    currency(value, currency, lang) {
        if(!currency) currency = 'EUR';
        return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(value);
    }
};



// WEBPACK FOOTER //
// ./src/filters/CurrencyFilters.js